export const LOADING_INITIAL = "LOADING_INITIAL";